var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {}, [
    _c("div", { staticClass: "col-12 marginBottom" }, [
      _c(
        "label",
        { staticClass: "control-label font-size-125 mb-3 textStyle" },
        [
          _vm._v(
            "\n            " +
              _vm._s(_vm._f("trans")("Choose a Style")) +
              "\n        "
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-12 d-flex flex-wrap rowGap" },
      _vm._l(this.conversionOptions, function (option, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "optionWrapper",
            on: {
              click: function ($event) {
                _vm.optionSelected = option.data_option
              },
            },
          },
          [
            _c("div", { staticClass: "imageWrapper mb-1" }, [
              _c(
                "div",
                {
                  class:
                    _vm.optionSelected === option.data_option
                      ? "checkMark"
                      : "hidden",
                },
                [_c("i", { staticClass: "far fa-check" })]
              ),
              _vm._v(" "),
              _c("img", {
                staticClass: "aiImage",
                class:
                  _vm.optionSelected === option.data_option
                    ? "selectedBorder"
                    : "",
                attrs: { src: option.image },
              }),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "textStyle" }, [
              _vm._v(_vm._s(option.name)),
            ]),
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "col-12 mt-4 marginBottom" }, [
      _c(
        "label",
        { staticClass: "control-label font-size-125 mb-3 textStyle" },
        [
          _vm._v(
            "\n            " +
              _vm._s(_vm._f("trans")("Choose a size")) +
              "\n        "
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-12 d-flex flex-wrap rowGap" }, [
      _c(
        "div",
        {
          staticClass: "aspectRationBoxOne",
          class: _vm.sizeSelected === "1:1" ? "selectedBorder" : "",
          on: {
            click: function ($event) {
              _vm.sizeSelected = "1:1"
            },
          },
        },
        [
          _c(
            "span",
            { class: _vm.sizeSelected === "1:1" ? "checkMarkTwo" : "hidden" },
            [_c("i", { staticClass: "far fa-check" })]
          ),
          _vm._v(" "),
          _c("div"),
          _vm._v(" "),
          _c("span", { staticClass: "textStyle" }, [_vm._v("1:1")]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "aspectRationBoxTwo",
          class: _vm.sizeSelected === "9:16" ? "selectedBorder" : "",
          on: {
            click: function ($event) {
              _vm.sizeSelected = "9:16"
            },
          },
        },
        [
          _c(
            "span",
            { class: _vm.sizeSelected === "9:16" ? "checkMarkTwo" : "hidden" },
            [_c("i", { staticClass: "far fa-check" })]
          ),
          _vm._v(" "),
          _c("div"),
          _vm._v(" "),
          _c("span", { staticClass: "textStyle" }, [_vm._v("9:16")]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "aspectRationBoxThree",
          class: _vm.sizeSelected === "16:9" ? "selectedBorder" : "",
          on: {
            click: function ($event) {
              _vm.sizeSelected = "16:9"
            },
          },
        },
        [
          _c(
            "span",
            { class: _vm.sizeSelected === "16:9" ? "checkMarkTwo" : "hidden" },
            [_c("i", { staticClass: "far fa-check" })]
          ),
          _vm._v(" "),
          _c("div"),
          _vm._v(" "),
          _c("span", { staticClass: "textStyle" }, [_vm._v("16:9")]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "hidden" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: this.optionSelected,
            expression: "this.optionSelected",
          },
        ],
        staticClass: "form-control",
        attrs: {
          id: "inputStyle",
          name: "style",
          "data-options-type": "options",
          "data-category": "operation",
          title: "",
        },
        domProps: { value: this.optionSelected },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.$set(this, "optionSelected", $event.target.value)
          },
        },
      }),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: this.sizeSelected,
            expression: "this.sizeSelected",
          },
        ],
        staticClass: "form-control",
        attrs: {
          id: "inputSize",
          name: "size",
          "data-options-type": "options",
          "data-category": "operation",
          title: "",
        },
        domProps: { value: this.sizeSelected },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.$set(this, "sizeSelected", $event.target.value)
          },
        },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }